import { getContext } from 'svelte';

const context = {
  subscribe: null,
  addBanner: null,
  removeBanner: null,
  clearBanners: null
};

export const getBannersContext = () => getContext(context);

export default context;
